import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Tracking } from '@freelancer/tracking';

@Component({
  standalone: false,
  selector: 'webapp-compat-tracking',
  template: ` <fl-tracking /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompatTrackingComponent implements OnInit {
  private tracking = inject(Tracking);

  ngOnInit(): void {
    const w = window as any;
    w.webappCompatTracking = {
      trackCustomEvent: (
        name: string,
        section: string,
        extraParams?: { [key: string]: string | number | string[] },
      ) => this.tracking.trackCustomEvent(name, section, extraParams),
    };

    // This callback function is defined at modules/@shared/ads-tracking-wrapper/index.js
    if (w.webappCompatTrackingReadyCallback) {
      w.webappCompatTrackingReadyCallback();
    }
  }
}
